import React from "react";
import { StaticContext } from "react-router";
import { Redirect, Route, RouteComponentProps, RouteProps } from "react-router-dom";
import { isUserAuthorized, isUserLoading, isUserSignedIn } from "../../auth";
import { Loader } from "../navigation";

interface ProtectedRouteProps extends RouteProps {
  authorizationPolicies?: string[];
}

export const ProtectedRouteComponent = (props: ProtectedRouteProps) => {
  const { component: Component, authorizationPolicies, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(routeProps: RouteComponentProps<any, StaticContext>) =>
        isUserLoading() ? (
          <Loader />
        ) : isUserSignedIn() ? (
          isUserAuthorized(authorizationPolicies) ? (
            Component && <Component {...routeProps} />
          ) : (
            <Redirect to={{ pathname: "/auth/not-authorized", state: { from: routeProps.location } }} />
          )
        ) : (
          <Redirect to={{ pathname: "/auth/signin", state: { from: routeProps.location } }} />
        )
      }
    />
  );
};

export const ProtectedRoute = ProtectedRouteComponent;
